import { FC, useRef } from 'react';
import TagPill from 'containers/tags/create-tag/Tag';
import { Tag } from 'containers/tags/tags.model';
import { TooltipWrapper } from 'components/tooltip/TooltipWrapper';

interface TableTagPillProps {
  tag: Tag;
  id?: string;
}

const TableTagPill: FC<TableTagPillProps> = ({ tag, id }) => {
  const textRef = useRef<HTMLSpanElement | null>(null);
  const isTooltipVisible = textRef.current && textRef.current.scrollWidth > textRef.current.clientWidth;

  return (
    <TooltipWrapper
      tooltip={tag.name}
      showTooltip={isTooltipVisible}
      position="top"
      className='inline-block h-fit w-fit max-w-full [&>[role="tooltip"]]:z-30'>
      <TagPill
        tag={tag}
        contentRef={textRef}
        className="w-full text-ellipsis rounded-[4px] px-1.5 py-1"
        textStyle="text-[13px] font-normal overflow-hidden text-ellipsis line-clamp-2"
        id={id}
      />
    </TooltipWrapper>
  );
};

export default TableTagPill;
